import { Component, OnInit, Input } from "@angular/core";
import { AngularFirestore } from "@angular/fire/firestore";
import { TranslateService } from "@ngx-translate/core";
import { FinanceTransaction } from "src/app/interfaces/finance";
import { InstallationPlace } from "src/app/interfaces/installation";
import { ApiService } from "src/app/services/api/api.service";
import { FunctionsService } from "src/app/services/functions/functions.service";

import html2canvas from 'html2canvas';
@Component({
  selector: 'transaction-print',
  templateUrl: './transaction-print.component.html',
  styleUrls: ['./transaction-print.component.scss'],
})
export class TransactionPrintComponent implements OnInit {
  transaction: FinanceTransaction;
  @Input() public transactionInput: FinanceTransaction;
  
  translations: any;
  modePrint = false;

  constructor(
    public translate: TranslateService, 
    private api: ApiService,
    private afs: AngularFirestore,
    private funcService: FunctionsService ){}
  ngOnInit() {
    console.log('transaction', this.transaction);
    if (this.transactionInput) {
      this.transaction = this.transactionInput;  
    }
  
  }

  async presentAlertPrint() {
    this.translate.get(['CANCEL', 'PRINT', 'PRINT_INFO', 'SAVE']).subscribe(async values => {
      this.translations = values;
      const alert = await this.funcService.alertCtrl.create({
        cssClass: 'my-custom-class',
        header: values.PRINT,
        message: values.PRINT_INFO,
        buttons: [
          {
            text: values.CANCEL,
            role: 'cancel',
            cssClass: 'secondary',
            handler: blah => {
              // console.log('Confirm Cancel: blah');
            },
          },,
          {
            text: values.SAVE,
            handler: () => {
             this.generateImg();
              // console.log('Confirm Okay');
            },
          },
          {
            text: values.PRINT,
            handler: () => {
              this.modePrint = true;
              setTimeout(() => {
           
                window.print();
                setTimeout(() => {
                  this.modePrint = false;
                }, 200);
              }, 500);
              // console.log('Confirm Okay');
            },
          },
        ],
      });

      await alert.present();
    });
  }

  async shareWhatsApp() {
    this.funcService.present('Cargando...');
    const number = await this.getCellphone(this.transaction.place.ref.id)
    console.log(number);
    if (number) {
        this.api.sendWhatsAppMessage(
        number,
        this.transaction.installation.name, this.transaction.place.name,  this.getTransactionType(this.transaction.concept), this.transaction.amount, this.transaction.id
      ).subscribe((res: any) => {
        console.log('res', res);
        
        this.funcService.dismiss();
        this.funcService.showToast('Mensaje enviado', 'success');
      }, (error) => {
        console.log('error', error)
        this.funcService.dismiss();
      }); 
    } else {
      
      this.funcService.dismiss();
      this.funcService.showToast('No se encontró el número de teléfono', 'danger');
    }
  }

  getTransactionType(concept: string): string {
    switch (concept) {
      case 'deposit_installation':
        return 'Deposito';
      case 'withdrawal_installation':
        return 'Retiro';
      default:
        return 'Tipo desconocido';
    }
  }

  async getCellphone(placeId: string): Promise<string | null> {
    try {
      const docRef = this.afs.collection('places').doc(placeId);
      const docSnapshot = await docRef.get().toPromise();
      if (docSnapshot.exists) {
        const data = docSnapshot.data() as undefined  as InstallationPlace ;
        // Asumiendo que siselse es un objeto dentro del documento y correo1 es una propiedad de ese objeto
        return data?.siselse?.telefono || null; // Retorna el correo o null si no se encuentra
      } else {
        console.log('No se encontró el documento con el ID proporcionado.');
        return null;
      }
    } catch (error) {
      console.error('Error al obtener el correo:', error);
      throw error; // O manejar el error de manera más específica
    }
  }

  generateImg() {
    const elementoHtml = document.getElementById('ticket'); // Reemplaza 'tuDiv' con el ID de tu div
   if (!elementoHtml) return;
    html2canvas(elementoHtml, {
      useCORS: true,
      logging: true,
      allowTaint: true,
    }).then((canvas) => {
      const imagenDataUrl = canvas.toDataURL('image/png');
      this.descargarImagen(imagenDataUrl);
    });
  }

  descargarImagen(dataUrl: string) {
    const a = document.createElement('a');
    a.href = dataUrl;
    a.download = this.transaction.id + '.png';
    a.click();
    
  }

}
